// Lib
import gql from 'graphql-tag';

// Types
import { POST } from '../types';

export const authFeedQuery = gql`
  query AuthFeed($input: AuthFeedInput!) {
    authFeed(input: $input) {
      items {
        ${POST}
      }
      hasMore
      cursor
    }
  }
`;
